<script>
    import { onMount } from "svelte";
    import { _log } from "./utils/logger";

    const isRequestIdleCallback = "requestIdleCallback" in window;
    let f;
    let canvas;
    let selections = [];
    let layers = [];
    let layersFiltered = [];
    let currentFilterLayer = "all layers";
    let interval;

    function initLayers() {
        const _objs = canvas.getObjects();
        const _layers = [];
        for (const layer of _objs) {
            if (layer.id) {
                _layers.push({ src: layer.toDataURL(), item: layer });
            }
        }
        layers = _layers;
        filterObj(currentFilterLayer);
        _log("layers", layers);
    }

    async function initLayersIdle(deadline) {
        const _objs = canvas.getObjects();
        const _layers = [];
        for (const layer of _objs) {
            if (layer.id) {
                _layers.push({ src: layer.toDataURL(), item: layer });
            }
        }
        layers = [..._layers];
        filterObj(currentFilterLayer);
        _log("initLayersIdle", deadline.timeRemaining());
    }

    function onSelectionHandler(e) {
        selections = f.getActiveObjects();
    }
    onMount(() => {
        _log("created layers")
        f = window.fabricHelper;
        canvas = f.getCanvas();
        initLayers();
        interval = setInterval(() => {
            _log("update layers");
            if (isRequestIdleCallback) {
                requestIdleCallback(initLayersIdle);
            } else {
                initLayers();
            }
        }, 10000);
        selections = f.getActiveObjects();
        canvas.on("object:removed", (e) => {
            _log("object:removed", e);
            const id = e.target.id;
            selections = selections.filter((v) => v.id && v.id !== id);
            layers = layers.filter((v) => v.item.id && v.item.id !== id);
            filterObj(currentFilterLayer);
        });
        canvas.on("object:added", (e) => {
            _log("object:added AA", e);

            const target = e.target;
            if (target.id) {
                layers = [{ src: target.toDataURL(), item: target }, ...layers];
                filterObj(currentFilterLayer);
            }
        });
        canvas.on("selection:created", onSelectionHandler);
        canvas.on("selection:updated", onSelectionHandler);
        canvas.on("selection:cleared", onSelectionHandler);
        return () => {
            _log("destroy layers")
            clearInterval(interval);
            canvas.off("selection:created", onSelectionHandler);
            canvas.off("selection:updated", onSelectionHandler);
            canvas.off("selection:cleared", onSelectionHandler);
        };
    });

    function imgClickHandler(e, layer) {
        _log("imgClickHandler",layer.item)
        canvas.setActiveObject(layer.item);
        setTimeout(() => {
        
            f.render()
        }, 0);
    }

    function filterObj(value) {
        _log("filterObj", value);
        layersFiltered = [...layers];

    }
    function onInputHandler(e) {
        const value = e.target.value;
        filterObj(value);
    }

    let moveInterval 
    function upmousedownHandler(){
        clearInterval(moveInterval)
        const objs = f.getActiveObjects();
        if(objs && objs[0]) {
            const obj = objs[0]
            moveInterval = setInterval(()=>{
                _log("moveInterval")
                obj.set({top: obj.top-=1})
                f.render()
            }, 20)
        }
    }
    function downmousedownHandler(){
        clearInterval(moveInterval)
        const objs = f.getActiveObjects();
        if(objs && objs[0]) {
            const obj = objs[0]
            moveInterval = setInterval(()=>{
                _log("moveInterval")
                obj.set({top: obj.top+=1})
                f.render()
            }, 20)
        }
    }
    function rightmousedownHandler(){
        clearInterval(moveInterval)
        const objs = f.getActiveObjects();
        if(objs && objs[0]) {
            const obj = objs[0]
            moveInterval = setInterval(()=>{
                _log("moveInterval")
                obj.set({left: obj.left+=1})
                f.render()
            }, 20)
        }
    }
    function leftmousedownHandler(){
        clearInterval(moveInterval)
        const objs = f.getActiveObjects();
        if(objs && objs[0]) {
            const obj = objs[0]
            moveInterval = setInterval(()=>{
                _log("moveInterval")
                obj.set({left: obj.left-=1})
                f.render()
            }, 20)
        }
    }
    
    function clearMoveHandler() {
        clearInterval(moveInterval)
    }

</script>

<div class="main-layers collapsable">
    <div class="shape-box-layers">
                <div
            color="secondary"
            class="roundedBtn"
            on:mousedown={leftmousedownHandler}
            on:mouseup={clearMoveHandler}
            on:touchstart={leftmousedownHandler}
            on:touchend={clearMoveHandler}
        >
        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon noselect" viewBox="0 0 512 512"><title>Left</title><path stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292" class="ionicon-fill-none"/></svg>
        </div>
        <div
            color="secondary"
            class="roundedBtn"
            on:mousedown={upmousedownHandler}
            on:mouseup={clearMoveHandler}
            on:touchstart={upmousedownHandler}
            on:touchend={clearMoveHandler}
        >
            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon noselect" viewBox="0 0 512 512"><title>Up</title><path stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M112 244l144-144 144 144M256 120v292" class="ionicon-fill-none"/></svg>
        </div>
        <div
            color="secondary"
            class="roundedBtn"
            on:mousedown={downmousedownHandler}
            on:mouseup={clearMoveHandler}
            on:touchstart={downmousedownHandler}
            on:touchend={clearMoveHandler}
        >
             <svg xmlns="http://www.w3.org/2000/svg" class="ionicon noselect" viewBox="0 0 512 512"><title>Down</title><path stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M112 268l144 144 144-144M256 392V100" class="ionicon-fill-none"/></svg>
        </div>

        <div
            color="secondary"
            class="roundedBtn"
            on:mousedown={rightmousedownHandler}
            on:mouseup={clearMoveHandler}
            on:touchstart={rightmousedownHandler}
            on:touchend={clearMoveHandler}
        >
        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon noselect" viewBox="0 0 512 512"><title>Right</title><path stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100" class="ionicon-fill-none"/></svg>
        </div>


    </div>
<div class="main-layers-items">
    {#if layersFiltered}
        {#each layersFiltered as layer}
            <figure class:active={selections.some((v) => v.id === layer.item.id)}>
                <!-- <div innerHTML={layer.src} /> -->
                <img
                    class="imgPreview noselect"
                    
                    src={layer.src}
                    alt=""
                    on:click={(e) => {
                        imgClickHandler(e, layer)
                    }}
                />
            </figure>
        {/each}
    {/if}
</div>

</div>